var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1Copy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2106 0.379883H1.75153C1.04307 0.379883 0.470703 0.952254 0.470703 1.66071V31.1198C0.470703 31.8283 1.04307 32.4007 1.75153 32.4007H31.2106C31.9191 32.4007 32.4915 31.8283 32.4915 31.1198V1.66071C32.4915 0.952254 31.9191 0.379883 31.2106 0.379883ZM27.5122 9.72595H24.9546C22.9493 9.72595 22.561 10.6786 22.561 12.0795V15.1655H27.3481L26.7237 19.9966H22.561V32.4007H17.5698V20.0006H13.3951V15.1655H17.5698V11.6032C17.5698 7.46848 20.0954 5.21502 23.7858 5.21502C25.555 5.21502 27.072 5.34711 27.5163 5.40715V9.72595H27.5122Z",
    fill: "#4D2E67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1Copy);
export default __webpack_public_path__ + "static/media/Vector-1 copy.d9884ed0.svg";
export { ForwardRef as ReactComponent };